// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__DN8Dt","slideDown":"styles_slideDown__1tttZ","slideUp":"styles_slideUp__5Inbk"};